import { Routes } from '@angular/router';
import { LifeLayoutComponent } from './layout/life-layout/life-layout.component';
export const lifeRoutes: Routes = [
    {
        path: 'life/quotes/:proposalId/:uuid',
       // component: LifeLayoutComponent,
        loadChildren: () => import('./modules/life-quotes/quotes.module').then(m => m.QuotesModule)
    }, {
        path: 'life/BI/:proposalId/:uuid',
        loadChildren: () => import('./modules/life-bi/life-bi.module').then(m => m.LifeBiModule)
    }, {
        path: 'life/proposal/:proposalId/:uuid',
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./modules/life-proposal/life-term-personal-details/life-proposal.module').then(m => m.LifeProposalModule)
    },
    {
        path: 'life/proposal/communication-details/:proposalId/:uuid',
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./modules/life-proposal/life-term-communication-details/life-term-communication-details.module').then(m => m.LifeTermCommunicationDetailsModule)
    },
    {
        path: 'life/proposal/lifestyle-details/:proposalId/:uuid',
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./modules/life-proposal/life-term-life-style-details/life-term-life-style-details.module').then(m => m.LifeTermLifeStyleDetailsModule)
    },
    {
        path: 'life/proposal/lifehealth-details/:proposalId/:uuid',
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./modules/life-proposal/life-term-health-details/life-term-health-details.module').then(m => m.LifeTermHealthDetailsModule)
    },
    {
        path: 'life/proposal/nominee/:proposalId/:uuid',
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./modules/life-proposal/life-nominee/life-nominee.module').then(m => m.LifeNomineeModule)
    },
    {
        path: 'life/proposal/bank/:proposalId/:uuid',
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./modules/life-proposal/life-bank/life-bank.module').then(m => m.LifeBankModule)
    },
    {
        path: 'life/proposal/previous-policy/:proposalId/:uuid',
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./modules/life-proposal/life-prv-policy-details/life-prv-policy-details.module').then(m => m.LifePrvPolicyDetailsModule)
    },
    {
        path: 'life/upload-document/:proposalId/:uuid',
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./modules/life-document/life-document.module').then(m => m.LifeDocumentModule)
    },
    {
        path: 'life/questionnaire/:proposalId/:uuid',
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./modules/life-questionnaire/life-questionnaire.module').then(m => m.LifeQuestionnaireModule)
    },
    {
        path: 'life/acr/:proposalId/:uuid',
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./modules/life-acr/life-acr.module').then(m => m.LifeAcrModule)
    },
    {
        path: 'life/review-pay/:proposalId/:uuid',
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./modules/life-review-pay/life-review-pay.module').then(m => m.LifeReviewPayModule)
    },

    {
        path: 'life/payment-success/:proposalId/:uuid',
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./modules/life-payment-success/life-payment-success.module').then(m => m.LifePaymentSuccessModule)
    },
    {
        path: 'life/payment-failure/:proposalId/:uuid',
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./modules/life-payment-failure/life-payment-failure.module').then(m => m.LifePaymentFailureModule)
    },
    {
        path: 'life/payment-pending/:proposalId/:uuid',
        // tslint:disable-next-line: max-line-length
        loadChildren: () => import('./modules/life-payment-pending/life-payment-pending.module').then(m => m.LifePaymentPendingModule)
    },

];


